export enum ShareLinkStatus {
  VALID = "VALID",
  EXPIRED = "EXPIRED",
  PASSWORD_PROTECTED = "PASSWORD_PROTECTED",
  CANCELED = "CANCELED",
  RESTRICTED = "RESTRICTED",
}